import React from "react";
import { TableCrypto } from "./TableCrypto";
import { TableGameCurrency } from "./TableGameCurrency";
import { TableOption } from "./TableOption";
import { useApp } from "../../../contexts";

export const TabWallet = ({ data }) => {
  const { convertToLocalCurrency, currency } = useApp();
  const convertData = (items) => {
    return (items || []).map((item) => {
      return {
        ...item,
        coin: item.currency_code,
        amount: item.dog_food,
        marketPrice: convertToLocalCurrency(item.currency_rate, "USD", currency),
        local: convertToLocalCurrency(item.balance, "USD", currency),
      };
    });
  };

  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] xls:gap-[60px] mt-[10px] lg:mt-[24px] xls:mt-[44px]">
      <TableCrypto data={convertData(data?.cryptos ?? [])} />
      <TableGameCurrency data={convertData(data?.games ?? [])} />
      <TableOption data={convertData(data?.options ?? [])} />
    </div>
  );
};
